<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('course.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('course.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('course.detail.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <course-info :course="course"></course-info>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h5>{{ $t('course.detail.label.livestream') }}</h5>
      </div>
      <div class="col-12" v-if="course.live_stream_url">
        <p v-if="afterTheCourse()">{{ $t('course.detail.message.has-ended') }}</p>
        <p v-else-if="beforeTheCourse()">{{ $t('course.detail.message.has-not-started-yet') }}</p>
        <live-streaming-player v-else :source="course.live_stream_url"></live-streaming-player>
      </div>
      <div class="col-12" v-else>
        <p>{{ $t('course.detail.message.none') }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-button :to="{ name: 'today-courses' }" variant="primary" block>{{ $t('course.detail.button.view-more.label') }}</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { LinkPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'

import CourseInfo from '@/components/info/CourseInfo'
import LiveStreamingPlayer from '@/components/players/LiveStreamingPlayer'

import i18n from '@/plugins/i18n.js'

import CourseApiService from '@/services/budaedu-api-services/course-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(IconsPlugin)
Vue.use(LinkPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)

Vue.use(CourseApiService)

export default {
  i18n,
  name: 'course',
  props: {
    id: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      course: null
    }
  },
  methods: {
    beforeTheCourse() {
      const start_date = dayjs(this.course.spkdate);
      const current_date = dayjs();
      return current_date.isBefore(start_date, 'day')
    },
    afterTheCourse() {
      if (this.course.enddate) {
        const end_date = dayjs(this.course.enddate);
        const current_date = dayjs();
        return current_date.isAfter(end_date, 'day')
      }
      return false
    },
    async setCourse() {
      const item = await this.$courseApiService.getById(this.id, 'include=lecturer,places')
      this.course = item.data
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`);
    await this.setCourse()
  },
  components: {
    CourseInfo,
    LiveStreamingPlayer
  },
  metaInfo() {
    const title = this.course
      ? `${this.course.title_full_name} ${this.course.lecturer.lecr_full_name}`
      : `${this.$t('course.title')}`
    
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>